import React from 'react';
import PropTypes from 'prop-types';
//import intl from 'react-intl-universal';
//import Dropdown from 'src/ui/library/Dropdown';
//import MenuItem from '@mui/material/MenuItem';
import BackIcon from '@mui/icons-material/ArrowBack';
import Button from 'src/ui/library/Button';
import { HISTORY_URL_MAPPER } from 'src/constants/constants';
//import { CASE_DETAIL_URL, MESSAGING_COMPOSE_URL } from 'src/constants/constants';

const getDisplayValue = item => {
  if (typeof item === 'undefined') return null;

  const { url, params } = item;
  const paramKeys = Object.keys(params);
  const historyKeys = Object.keys(HISTORY_URL_MAPPER);

  const transformedMap = historyKeys.reduce((acc, next) => {
    let curKey = next;
    let curVal = HISTORY_URL_MAPPER[next];

    paramKeys.forEach(curParam => {
      curKey = curKey.split(`#${curParam}#`).join(params[curParam]);
      curVal = curVal.split(`#${curParam}#`).join(params[curParam]);
    });

    acc[curKey] = curVal;
    return acc;
  }, {});

  if (Object.prototype.hasOwnProperty.call(transformedMap, url)) return transformedMap[url];
  else return url;
};

export const HistoryDisplayPres = React.forwardRef(({ history, historyList, onChange, isOpen = false }, ref) => {
  const onBack = () => {
    if (history && typeof history.goBack === 'function') history.goBack();
  };

  //const historyListTruncated = [...historyList].slice(1, historyList.length);

  return (
    <div ref={ref} className="history-display-wrapper">
      <Button
        styleType={'blue-button'}
        style={{ backgroundColor: '#FFF' }}
        onClick={() => {
          onBack();
        }}>
        <BackIcon /> Back
      </Button>

      <Button
        styleType={'down-button'}
        onClick={() => {
          onChange();
        }}>
        <i className="downArrow" />
      </Button>

      <span className="selected-item">{getDisplayValue(historyList[0])}</span>
      {isOpen && !!historyList.length && (
        <div className="history-display-dropdown">
          <ul>
            {historyList.map((val, i) => {
              return (
                <li
                  key={i}
                  onClick={() => {
                    if (history && typeof history.push === 'function') history.push(val.url);
                  }}>
                  {getDisplayValue(val)}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
});

HistoryDisplayPres.displayName = 'HistoryDisplayPres';

HistoryDisplayPres.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func,
  }),
  historyList: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      params: PropTypes.object,
    }),
  ).isRequired,
  isOpen: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default HistoryDisplayPres;
